import React from 'react';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import Login from './pages/Login';
import Profile from './pages/Profile';

function PrivateRoute(props) {
  const auth = useAuth();
  const Component = props.component;

  return (
    <Route
      path={props.path}
      exact={props.exact}
      render={function (routeProps) {
        if (!auth.isAuthenticated) {
          return <Redirect to="/login" />;
        }
        return <Component {...routeProps} />;
      }}
    />
  );
}

function GuestRoute(props) {
  const auth = useAuth();
  const Component = props.component;

  return (
    <Route
      path={props.path}
      exact={props.exact}
      render={function (routeProps) {
        if (auth.isAuthenticated) {
          return <Redirect to="/profile" />;
        }
        return <Component {...routeProps} />;
      }}
    />
  );
}

function Routes() {
  return (
    <Switch>
      <GuestRoute exact path="/login" component={Login} />
      <PrivateRoute exact path="/profile" component={Profile} />
      <Redirect to="/login" />
    </Switch>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <HashRouter>
        <Routes />
      </HashRouter>
    </AuthProvider>
  );
}
